import Home from './Home.bundle-pool-bulk.vue'

export default {
  Home
}